var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ugo-page"},[_vm._v(" objects:"+_vm._s(_vm.id)+" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }